import React from "react";
import { styled } from "@mui/material/styles";
import { Button, Typography } from "@mui/material";
import { ReactComponent as IconPlus } from "../../common/assets/images/iconPlus.svg";
import { useNavigate } from "react-router-dom";

const PREFIX = "AddButton";

const classes = {
  addPeerGroup: `${PREFIX}-addPeerGroup`,
};

const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${classes.addPeerGroup}`]: {
    "marginTop": "1rem",
    "display": "flex",
    "width": "fit-content",
    "height": "fit-content",
    "cursor": "pointer",
    "padding": 0,
    "& svg": {
      marginRight: "1rem",
      height: 80,
      width: 80,
    },
    "& div": {
      "padding": "1rem 0",
      "& p": {
        textAlign: "left",
        color: theme.palette.primary.main,
        fontWeight: 700,
        fontSize: "1.25rem",
      },
    },
    "&:hover, &.Mui-focusVisible": {
      "backgroundColor": "transparent",
      "& #Rectangle-Copy-3": {
        fill: theme.palette.primary.main,
        stroke: "#a58922",
      },
      "& #Combined-Shape": {
        fill: "#ffffff",
      },
    },
  },
}));

interface Props {
  title: string;
  path: string;
  onClick?: () => void;
}
function AddButton({ title, path, onClick }: Props) {
  const navigate = useNavigate();
  return (
    <StyledButton
      className={classes.addPeerGroup}
      onClick={() => {
        onClick?.();
        navigate({
          pathname: path,
        });
      }}
    >
      <IconPlus />
      <div>
        <Typography>{title}</Typography>
      </div>
    </StyledButton>
  );
}
export default AddButton;
